import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { scalar } from '@tensorflow/tfjs-core';
import { TensorArray } from '../../executor/tensor_array';
import { getParamValue, getTensor } from './utils';
export var executeOp = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node, tensorMap, context) {
    var thenFunc, elseFunc, cond, args, condValue, bodyFunc, condFunc, _args, condTensor, _condValue, result, _condTensor, pred, _data, inputName, frameId, data, tensor, input, size, dtype, elementShape, dynamicSize, clearAfterRead, identicalElementShapes, name, tensorArray, id, index, writeTensor, writeTensorArray, readId, readIndex, readTensorArray, gatherId, gatherIndices, gatherDtype, gatherTensorArray, scatterId, scatterIndices, scatterTensor, scatterTensorArray, concatId, concatTensorArray, concatDtype, splitId, splitTensor, lengths, splitTensorArray, sizeId, sizeTensorArray, closeId, closeTensorArray;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = node.op;
            _context.next = _context.t0 === 'If' ? 3 : _context.t0 === 'StatelessIf' ? 3 : _context.t0 === 'While' ? 15 : _context.t0 === 'StatelessWhile' ? 15 : _context.t0 === 'LoopCond' ? 38 : _context.t0 === 'Switch' ? 39 : _context.t0 === 'Merge' ? 49 : _context.t0 === 'Enter' ? 51 : _context.t0 === 'Exit' ? 55 : _context.t0 === 'NextIteration' ? 58 : _context.t0 === 'TensorArrayV3' ? 61 : _context.t0 === 'TensorArrayWriteV3' ? 71 : _context.t0 === 'TensorArrayReadV3' ? 77 : _context.t0 === 'TensorArrayGatherV3' ? 81 : _context.t0 === 'TensorArrayScatterV3' ? 86 : _context.t0 === 'TensorArrayConcatV3' ? 92 : _context.t0 === 'TensorArraySplitV3' ? 96 : _context.t0 === 'TensorArraySizeV3' ? 102 : _context.t0 === 'TensorArrayCloseV3' ? 105 : 109;
            break;

          case 3:
            thenFunc = getParamValue('thenBranch', node, tensorMap, context);
            elseFunc = getParamValue('elseBranch', node, tensorMap, context);
            cond = getParamValue('cond', node, tensorMap, context);
            args = getParamValue('args', node, tensorMap, context);
            _context.next = 9;
            return cond.data();

          case 9:
            condValue = _context.sent;

            if (!condValue[0]) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", context.functionMap[thenFunc].executeFunctionAsync(args));

          case 14:
            return _context.abrupt("return", context.functionMap[elseFunc].executeFunctionAsync(args));

          case 15:
            bodyFunc = getParamValue('body', node, tensorMap, context);
            condFunc = getParamValue('cond', node, tensorMap, context);
            _args = getParamValue('args', node, tensorMap, context);
            _context.next = 20;
            return context.functionMap[condFunc].executeFunctionAsync(_args);

          case 20:
            condTensor = _context.sent[0];
            _context.next = 23;
            return condTensor.data();

          case 23:
            _condValue = _context.sent;
            result = _args;

          case 25:
            if (!_condValue[0]) {
              _context.next = 37;
              break;
            }

            _context.next = 28;
            return context.functionMap[bodyFunc].executeFunctionAsync(result);

          case 28:
            result = _context.sent;
            _context.next = 31;
            return context.functionMap[condFunc].executeFunctionAsync(result);

          case 31:
            _condTensor = _context.sent[0];
            _context.next = 34;
            return _condTensor.data();

          case 34:
            _condValue = _context.sent;
            _context.next = 25;
            break;

          case 37:
            return _context.abrupt("return", result);

          case 38:
            return _context.abrupt("return", [getParamValue('pred', node, tensorMap, context).clone()]);

          case 39:
            pred = getParamValue('pred', node, tensorMap, context);
            _data = getParamValue('data', node, tensorMap, context); // Outputs nodes :0 => false, :1 => true

            _context.next = 43;
            return pred.data();

          case 43:
            if (!_context.sent[0]) {
              _context.next = 47;
              break;
            }

            _context.t1 = [undefined, _data.clone()];
            _context.next = 48;
            break;

          case 47:
            _context.t1 = [_data.clone(), undefined];

          case 48:
            return _context.abrupt("return", _context.t1);

          case 49:
            inputName = node.inputNames.find(function (name) {
              return getTensor(name, tensorMap, context) !== undefined;
            });
            return _context.abrupt("return", inputName ? [getTensor(inputName, tensorMap, context).clone()] : undefined);

          case 51:
            frameId = getParamValue('frameName', node, tensorMap, context);
            data = getParamValue('tensor', node, tensorMap, context);
            context.enterFrame(frameId);
            return _context.abrupt("return", [data.clone()]);

          case 55:
            tensor = getParamValue('tensor', node, tensorMap, context);
            context.exitFrame();
            return _context.abrupt("return", [tensor.clone()]);

          case 58:
            input = getParamValue('tensor', node, tensorMap, context);
            context.nextIteration();
            return _context.abrupt("return", [input.clone()]);

          case 61:
            size = getParamValue('size', node, tensorMap, context);
            dtype = getParamValue('dtype', node, tensorMap, context);
            elementShape = getParamValue('elementShape', node, tensorMap, context);
            dynamicSize = getParamValue('dynamicSize', node, tensorMap, context);
            clearAfterRead = getParamValue('clearAfterRead', node, tensorMap, context);
            identicalElementShapes = getParamValue('identicalElementShapes', node, tensorMap, context);
            name = getParamValue('name', node, tensorMap, context);
            tensorArray = new TensorArray(name, dtype, size, elementShape, identicalElementShapes, dynamicSize, clearAfterRead);
            context.addTensorArray(tensorArray);
            return _context.abrupt("return", [scalar(tensorArray.id), scalar(1.0)]);

          case 71:
            id = getParamValue('tensorArrayId', node, tensorMap, context);
            index = getParamValue('index', node, tensorMap, context);
            writeTensor = getParamValue('tensor', node, tensorMap, context);
            writeTensorArray = context.getTensorArray(id);
            writeTensorArray.write(index, writeTensor);
            return _context.abrupt("return", [scalar(1.0)]);

          case 77:
            readId = getParamValue('tensorArrayId', node, tensorMap, context);
            readIndex = getParamValue('index', node, tensorMap, context);
            readTensorArray = context.getTensorArray(readId);
            return _context.abrupt("return", [readTensorArray.read(readIndex)]);

          case 81:
            gatherId = getParamValue('tensorArrayId', node, tensorMap, context);
            gatherIndices = getParamValue('indices', node, tensorMap, context);
            gatherDtype = getParamValue('dtype', node, tensorMap, context);
            gatherTensorArray = context.getTensorArray(gatherId);
            return _context.abrupt("return", [gatherTensorArray.gather(gatherIndices, gatherDtype)]);

          case 86:
            scatterId = getParamValue('tensorArrayId', node, tensorMap, context);
            scatterIndices = getParamValue('indices', node, tensorMap, context);
            scatterTensor = getParamValue('tensor', node, tensorMap, context);
            scatterTensorArray = context.getTensorArray(scatterId);
            scatterTensorArray.scatter(scatterIndices, scatterTensor);
            return _context.abrupt("return", [scalar(1.0)]);

          case 92:
            concatId = getParamValue('tensorArrayId', node, tensorMap, context);
            concatTensorArray = context.getTensorArray(concatId);
            concatDtype = getParamValue('dtype', node, tensorMap, context);
            return _context.abrupt("return", [concatTensorArray.concat(concatDtype)]);

          case 96:
            splitId = getParamValue('tensorArrayId', node, tensorMap, context);
            splitTensor = getParamValue('tensor', node, tensorMap, context);
            lengths = getParamValue('lengths', node, tensorMap, context);
            splitTensorArray = context.getTensorArray(splitId);
            splitTensorArray.split(lengths, splitTensor);
            return _context.abrupt("return", [scalar(1.0)]);

          case 102:
            sizeId = getParamValue('tensorArrayId', node, tensorMap, context);
            sizeTensorArray = context.getTensorArray(sizeId);
            return _context.abrupt("return", [scalar(sizeTensorArray.size(), 'int32')]);

          case 105:
            closeId = getParamValue('tensorArrayId', node, tensorMap, context);
            closeTensorArray = context.getTensorArray(closeId);
            closeTensorArray.clearAndClose();
            return _context.abrupt("return", [scalar(0)]);

          case 109:
            throw TypeError("Node type ".concat(node.op, " is not implemented"));

          case 110:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function executeOp(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var CATEGORY = 'control';